import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from './RichText.module.css';

// Fora do componente: o ReactQuill recria o editor se `modules` mudar de identidade
const MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
};

// Só os formatos da barra: o que vier colado de fora (cores, títulos, imagens) é descartado
const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet'];

/**
 * Caixa de texto com formatação básica (negrito, itálico, sublinhado, listas
 * numerada e com marcadores). O valor é HTML; para exibir use `RichTextView`.
 *
 * `onChange(html)` só é chamado em edições da pessoa: a normalização que o
 * editor faz ao receber o valor não conta como alteração.
 */
const RichTextField = ({ label, value, onChange, placeholder, minHeight = 140 }) => {
  function handleChange(html, delta, source) {
    if (source === 'user' && onChange) onChange(html);
  }

  return (
    <div className={styles.field}>
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.editor} style={{ '--rich-text-min-height': `${minHeight}px` }}>
        <ReactQuill
          theme="snow"
          value={value || ''}
          onChange={handleChange}
          modules={MODULES}
          formats={FORMATS}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default RichTextField;
